import classNames from 'classnames';
import React from 'react';

import Typography from '../Typography/index.js';

import { X as CloseIcon } from '../Icon/index.js';

export interface PillProps extends React.PropsWithChildren {
  /**
   * @ignore
   * Classes applied to the root element.
   */
  className?: string;

  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled?: boolean;

  /**
   * If `true`, the component is in an error state.
   * @default false
   */
  error?: boolean;

  /**
   * If specified an X icon will be shown.
   */
  onClose?: () => void;
}

/**
 * Pill badges are used to indicate a selection of an item, and are typically used when
 * there are more than 1 item selected in a list that is being displayed horizontally.
 *
 * @see https://www.figma.com/file/LdhxwbVqKRRLpyK5ekr4Q8/Component-Library?node-id=1812%3A1933
 */
const Pill = React.forwardRef<HTMLDivElement, PillProps>(
  ({ children, className, disabled = false, error, onClose }, ref) => {
    const classes = classNames('pill', { disabled, error }, className);

    return (
      <div className={classes} aria-disabled={disabled} role="status" ref={ref}>
        <Typography
          color={disabled ? 'disabled' : 'default'}
          className="pill-text"
          variant="title-small"
        >
          {children}
        </Typography>
        {onClose && (
          <CloseIcon
            size="small"
            tabIndex={disabled ? -1 : 0}
            aria-disabled={disabled}
            className={classNames('pill__icon', { disabled: disabled })}
            onClick={disabled ? undefined : onClose}
            cursor={disabled ? 'not-allowed' : 'pointer'}
          />
        )}
      </div>
    );
  },
);

Pill.displayName = 'Pill';

export default Pill;
